import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Grid, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useWeights } from '../hooks/useWeights';

interface WeightEntryPageProps {
  onBack?: () => void;
}

const WeightEntryPage: React.FC<WeightEntryPageProps> = ({ onBack }) => {
  const [weight, setWeight] = useState('');
  const [unit, setUnit] = useState<'lbs' | 'kg'>('lbs');
  const [submitted, setSubmitted] = useState(false);
  const { createWeight, loading, error } = useWeights();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await createWeight({ weight: Number(weight), unit });
    if (success) {
      setSubmitted(true);
      setTimeout(() => {
        setWeight('');
        setSubmitted(false);
      }, 1500);
    }
  };

  return (
    <Box sx={{ maxWidth: 420, mx: 'auto', mt: 8, p: 3, bgcolor: '#fff', borderRadius: 3, boxShadow: 2, position: 'relative' }}>
      {onBack && (
        <Button
          onClick={onBack}
          variant="text"
          size="small"
          sx={{ position: 'absolute', top: 8, left: 8, minWidth: 0, p: 1 }}
        >
          <CloseIcon sx={{ color: '#222', fontSize: 32 }} />
        </Button>
      )}
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, mt: 4, textAlign: 'center' }}>
        Weight Entry
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <TextField
              label={`Weight (${unit})`}
              type="number"
              value={weight}
              onChange={e => setWeight(e.target.value)}
              fullWidth
              required
              inputProps={{ min: 1 }}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel>Unit</InputLabel>
              <Select
                value={unit}
                label="Unit"
                onChange={e => setUnit(e.target.value as 'lbs' | 'kg')}
              >
                <MenuItem value="lbs">lbs</MenuItem>
                <MenuItem value="kg">kg</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading || submitted}
              sx={{ py: 1.2, fontSize: '1.1rem', borderRadius: 8, backgroundColor: '#00A3FF', '&:hover': { backgroundColor: '#0091E6' } }}
            >
              {submitted ? 'Submitted!' : loading ? 'Saving...' : 'Submit'}
            </Button>
          </Grid>
          {error && (
            <Grid item xs={12}>
              <Typography color="error" sx={{ textAlign: 'center' }}>
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </Box>
  );
};

export default WeightEntryPage;
